<template>
  <div class="fastest-lap-input">
    <div class="ims-row center mb-2">
      <input @focus="$event.target.select()" class="first" v-model="whole" />
      <label>.</label>
      <input @focus="$event.target.select()" class="last" v-model="decimal" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      whole: `000`,
      decimal: `000`
    };
  },
  props: {
    value: {
      default() {
        return "000.000";
      }
    }
  },
  methods: {
    pad(numStr) {
      numStr = numStr.replace(/[^0-9]/g, "");
      if (numStr.length == 0) {
        return "000";
      } else if (numStr.length == 1) {
        return `${numStr}00`;
      } else if (numStr.length == 2) {
        return `${numStr}0`;
      } else if (numStr.length == 3) {
        return numStr.toString();
      } else {
        return numStr.toString().substr(0, 3);
      }
    }
  },
  watch: {
    value() {},
    whole() {
      if (this.whole.toString().length > 3) {
        this.whole = this.whole.toString().substr(0, 3);
      }
      this.$emit("input", `${this.pad(this.whole)}.${this.pad(this.decimal)}`);
    },
    decimal() {
      if (this.decimal.toString().length > 3) {
        this.decimal = this.decimal.toString().substr(0, 3);
      }
      this.$emit("input", `${this.pad(this.whole)}.${this.pad(this.decimal)}`);
    }
  },
  mounted() {
    if (this.value) {
      let valueSplit = this.value.toString().split(".");
      this.whole = this.pad(valueSplit[0]);
      this.decimal = this.pad(valueSplit[1]);
    }
  }
};
</script>

<style lang="scss">
@import "../../scss/utils/variables";
@import "../../scss/vendors/bootstrap-utils";

.fastest-lap-input {
  label {
    font-size: 40px;
  }
  input {
    border: solid 1px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    font-size: 32px;
    height: 50px;
    width: 90px;
    text-align: center;
    @include media-breakpoint-up(md) {
      width: 120px;
    }
  }
}
</style>